<template>
  <div class="t-flex t-items-center t-justify-center t-mt-5">
    <div class="t-flex t-flex-col t-space-y-8 lg:t-w-13/20 lg:t-mr-8">
      <section
        class="dashboard-content t-flex-col t-rounded-md t-p-4 t-bg-white"
      >
        <div style="border-bottom: 2px solid #EEEEEE;" class="t-pt-2 t-pb-4">
          <h3 class="t-text-lg t-text-center">
            File is being generated
          </h3>
        </div>
        <div class="t-text-lg t-text-center t-py-8">
          <i class="fa fa-spinner fa-3x fa-spin"></i>
          <p class="t-mt-4">
            The page will automatically refresh when the file is ready.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "file-generating",
  components: {},
  props: ["url"],
  data() {
    return {};
  },

  mounted() {
    this.checkFile();
  },

  methods: {
    checkFile() {
      setTimeout(() => {
        axios
          .get(this.url, { headers: { Accept: "application/json" } })
          .then(response => {
            this.redirect();
          })
          .catch(error => {});
        this.checkFile();
      }, 3000);
    },

    redirect() {
      location.reload();
    }
  }
};
</script>
